import React from "react";
import numeral from "numeral";

interface IPopulationProps {
  population: number;
}

export default function GovernmentPopulation({ population }: IPopulationProps) {
  if (population < 1000) {
    return <span>{population}</span>;
  }

  if (population >= 1000 && population < 1000000) {
    return <span>{numeral(population).format("0.0a")}</span>;
  }

  return <span>{numeral(population).format("0.00a")}</span>;
}
